<div class="app-shell" [class.is-collapsed]="isSidebarCollapsed">
  <app-sidenav [collapsed]="isSidebarCollapsed" (closed)="isSidebarCollapsed = true"></app-sidenav>

  <div class="app-content">
    <header class="app-topbar">
      <button class="sidebar-toggle" type="button" (click)="toggleSidebar()" aria-label="Plegar panel lateral">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
          stroke-linejoin="round">
          <path d="M4 7h16"></path>
          <path d="M4 12h16"></path>
          <path d="M4 17h16"></path>
        </svg>
      </button>
      <div class="welcome">
        Bienvenido, <span>{{ userName }}</span>
      </div>
    </header>

    <main class="app-main">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<div
  *ngIf="!isSidebarCollapsed"
  class="sidebar-overlay"
  (click)="toggleSidebar()"
  aria-hidden="true"
></div>

<ngx-spinner
  [name]="spinnerName"
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="square-jelly-box"
  [fullScreen]="true">
  <p style="color: white"> Cargando... </p>
</ngx-spinner>
